import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import BaseModal from "../../library/modal/BaseModal";

class ApiErrorModalInitializer extends Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      showModal: false,
      errorMessage: null
    };
    if (this.props.updateState) {
      this.props.updateState('apiErrorModalInitializer');
    }
  }

  onError = (error) => {
    this.setState( {
      showModal: true,
      error: error
    });
  };

  onClose = () => {
    this.setState( { showModal: false });
  };

  render() {
    let errorResponse;
    if (this.state.error && this.state.error.response) {
      errorResponse = this.state.error.response;
    }

    return (
        <BaseModal show={this.state.showModal} onClose={() => this.onClose() }>
          {errorResponse &&
          <div>
            <div>{errorResponse.status}</div>
            <div>{errorResponse.statusText}</div>
          </div>}
        </BaseModal>
    )
  };
}

ApiErrorModalInitializer.propTypes = {
  updateState: PropTypes.func
};

export default ApiErrorModalInitializer;